// 2020-06-27export { MyGroupCorralTropaComponent } from './my-group-corral-tropa.component';